import type { MoveTldRequest } from "@kilat/contracts/tld-pricing";
import { useMutation } from "@tanstack/react-query";
import { moveTld } from "../api";
import { pricingKeys } from "../queries";

// The answer is the whole list in its new order: it replaces the cached one, no refetch needed.
export const useMoveTld = (tldId: string) =>
  useMutation({
    mutationFn: (direction: MoveTldRequest["direction"]) => moveTld(tldId, { direction }),
    onSuccess: ({ data }, _direction, _result, { client }) => {
      client.setQueryData(pricingKeys.tlds(), data);
    },
  });
